import { render, staticRenderFns } from "./ValidationOrder.vue?vue&type=template&id=1a4d9512"
import script from "./ValidationOrder.vue?vue&type=script&lang=js"
export * from "./ValidationOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports